import * as React from 'react';

import Container from './styles';

const Tag = ({ type, children }) => {
  return <Container type={type}>{children || type}</Container>;
};

export default Tag;
